
define('jst!conversations/_live_event',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<div class="image-block">\n  <div class="img icon">\n    <span class="icon-16 <%=icon%>"></span>\n  </div>\n  <div class="bd text">\n    <%= translations.text %>\n  </div>\n  <% if (url !== null) { %>\n    <div class="bd text">\n      <a href="<%= url %>" target="_blank"><%= translations.join %></a>\n    </div>\n  <% } %>\n</div>\n');
 });

